import { SITUACAO_INSCRICAO_ADVOGADO } from './SituacaoInscricaoAdvogado';
import { SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO } from './SituacaoInscricoesAdvogadosProcesso';
import { MODO_PARTICIPACAO_ADVOGADO } from './ModoParticipacaoAdvogado';

/**
 * @classdesc Agrega as regras semânticas relacionadas às situações de inscrições de advogados no processo.
 * @readonly
 */
class SituacaoInscricoesAdvogadosProcessoBusiness {
    totalizadorSituacoesNegocio;
    registro;

    constructor(registro) {
        this.totalizadorSituacoesNegocio = new Map();
        this.resetContabilizadores();
        this.registro = registro;
    }

    resetContabilizadores() {
        Object.keys(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO).forEach((key) => {
            this.totalizadorSituacoesNegocio.set(key, 0);
        });
    }

    getSituacoes() {
        this.contabilizarSituacoes();
        let situacoes = [];

        for (const [key, value] of this.totalizadorSituacoesNegocio) {
            if (value) {
                situacoes.push(key);
            }
        }

        return situacoes;
    }

    adicionar(situacaoId) {
        const total = this.totalizadorSituacoesNegocio.get(situacaoId);
        this.totalizadorSituacoesNegocio.set(situacaoId, total ? total + 1 : 1);
    }

    contabilizarSituacoes() {
        if (
            !this.registro.pedidoSustentacaoOral ||
            !this.registro.pedidoSustentacaoOral.pedidosDetalhados ||
            !this.registro.pedidoSustentacaoOral.pedidosDetalhados.length
        ) {
            return;
        }

        this.registro.pedidoSustentacaoOral.pedidosDetalhados.forEach((pedido) => {
            pedido.advogados &&
                pedido.advogados.forEach((adv) => {
                    if (adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) {
                        return;
                    }

                    // Advogado inscrito
                    this.adicionar(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_INSCRITO.id);

                    // Advogado presente
                    if (adv.presente === SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.codigo) {
                        this.adicionar(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE.id);

                        // Advogado presente presencialmente
                        if (adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo) {
                            this.adicionar(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_PRESENCIALMENTE.id);
                        }

                        // Advogado presente telepresencialmente
                        if (adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo) {
                            this.adicionar(
                                SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_TELEPRESENCIALMENTE.id
                            );
                        }
                    }

                    // Advogado sem informação de presença
                    if (adv.presente === SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.codigo) {
                        this.adicionar(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_SEM_INFORMACAO_PRESENCA.id);
                    }

                    // Advogado ausente
                    if (adv.presente === SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.codigo) {
                        this.adicionar(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_AUSENTE.id);
                    }
                });
        });

        // TODOS os advogados ausentes
        const totalAdvogadosAusentes = this.totalizadorSituacoesNegocio.get(
            SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_AUSENTE.id
        );
        const totalAdvogadosInscritos = this.totalizadorSituacoesNegocio.get(
            SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_INSCRITO.id
        );

        if (totalAdvogadosAusentes && totalAdvogadosAusentes === totalAdvogadosInscritos) {
            this.adicionar(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_TODOS_ADV_AUSENTES.id);
        }
    }
}

export default SituacaoInscricoesAdvogadosProcessoBusiness;
